import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../../../../utils/api";
import { useErrorSuccess } from "../../../../../hooks/useErrorSuccess";
import { useServicesMembroBatismo } from "../../context/getServices";

const ServicesMembros = () => {

  const { id } = useParams()

  const { listAll } = useServicesMembroBatismo()

  const { setMensagemError, setMensagemInfo } = useErrorSuccess();

  const [usuario, setUsuario] = useState<any>();

  const getUsuario = async () => {
    try {
      const req = listAll?.find((membro) => membro?.id == id);
      setUsuario(req);

    } catch (error) {
      setMensagemError(JSON.stringify(error?.response?.data, null, 2))
    }
  }

  const { } = useQuery({
    queryKey: ['usuario-get', id],
    queryFn: getUsuario
  })

  const alterUsuario = (field: string, value: any) => {
    setUsuario((val) => ({...val, [field]: value}))
  }

  const updateUser = async () => {
    try {
      const req = await api.put(`usuario/${id}`, usuario);
      const res = await req.data;
      setMensagemInfo('Usuário atualizado!');
    } catch (error) {
      setMensagemError(JSON.stringify(error?.response?.data, null, 2))
    }
  }

  return {
    usuario,
    alterUsuario,
    updateUser
  };
}

export default ServicesMembros;
